export default __webpack_public_path__ + "static/media/inner_page_header_contact.55ef39f7.png";